// extracted by mini-css-extract-plugin
module.exports = {"content":"Users_content__Xcr2X","layout":"Users_layout__3cHFC"};